import React, { useEffect } from 'react';
import { Modal, Form, DatePicker, TimePicker, Button, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
export interface SendInvoiceModalProps {
  open: boolean;
  loading?: boolean;
  onCancel: () => void;
  /** ISO-строка даты/времени отправки клиенту */
  onSend: (sentToClientAtIso: string) => void;
}

const SendInvoiceModal: React.FC<SendInvoiceModalProps> = ({ open, loading, onCancel, onSend }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      const now = dayjs();
      form.setFieldsValue({ sendDate: now, sendTime: now });
    }
  }, [open, form]);

  const handleSubmit = async () => {
    const v = await form.validateFields();
    const d = v.sendDate as Dayjs;
    const t = v.sendTime as Dayjs;
    const combined = d.hour(t.hour()).minute(t.minute()).second(0).millisecond(0);
    onSend(combined.toISOString());
  };

  return (
    <Modal
      title="Отправить счёт клиенту"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width={400}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="sendDate" label="Дата отправки" rules={[{ required: true, message: 'Укажите дату' }]}>
          <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />
        </Form.Item>
        <Form.Item name="sendTime" label="Время" rules={[{ required: true, message: 'Укажите время' }]}>
          <TimePicker style={{ width: '100%' }} format="HH:mm" />
        </Form.Item>
        <Space>
          <Button type="primary" loading={loading} onClick={() => void handleSubmit()}>
            Отправить
          </Button>
          <Button onClick={onCancel}>Отмена</Button>
        </Space>
      </Form>
    </Modal>
  );
};

export default SendInvoiceModal;
